export default new URL("../images/places/place-4.jpg", import.meta.url).href;